<template>
  <div>
    <!-- Botão de importação -->
    <div class="row mr-1 mb-2">
      <div class="col-12" align="right">
        <button class="btn btn-add" @click="openImportModal">
          <i class="fas fa-file-excel"></i> Importar Usuários
        </button>
      </div>
    </div>

    <!-- Modal de Importação -->
    <div
      class="modal fade"
      id="importModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="importModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="importModalLabel">
              Importar Usuários em Massa
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Fechar"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="alert alert-info" role="alert">
              A planilha deve conter as colunas
              <strong>usuario_nome</strong> (ou <strong>nome</strong>) e
              <strong>login</strong>. Uma senha padrão
              <strong>Alterar123</strong> será definida para todos os usuários
              importados.
            </div>

            <div class="form-group">
              <label><span class="required">*</span> Empresa:</label>
              <select
                class="form-control"
                v-model="importForm.company_id"
                @change="onImportCompanyChange"
              >
                <option :value="null">Selecione</option>
                <option
                  v-for="company in companies"
                  :key="company.id"
                  :value="company.id"
                >
                  {{ company.name }}
                </option>
              </select>
            </div>

            <div class="form-group">
              <label><span class="required">*</span> Unidades:</label>
              <select
                class="form-control"
                v-model="importForm.unit_id"
                :disabled="!importForm.company_id"
              >
                <option :value="null">Selecione</option>
                <option
                  v-for="unit in filteredImportUnits"
                  :key="unit.id"
                  :value="unit.id"
                >
                  {{ unit.name }}
                </option>
              </select>
            </div>

            <div class="form-group">
              <label
                ><span class="required">*</span> Planilha (.xlsx, .xls,
                .csv):</label
              >
              <input
                ref="fileImportRef"
                name="fileImport"
                id="fileImport"
                type="file"
                class="form-control-file"
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              />
            </div>

            <div
              class="alert alert-success mt-2"
              role="alert"
              v-if="importSuccess && importedCount > 0"
            >
              <i class="fas fa-check-circle"></i>
              <strong>
                {{ importedCount }} usuário(s) importado(s) com sucesso!</strong
              >
              <span v-if="importErrors.length">
                {{ importErrors.length }} linha(s) com problema foram
                ignoradas.</span
              >
            </div>

            <div
              class="alert alert-warning mt-2"
              v-if="importSuccess && importedCount === 0 && importErrors.length"
            >
              <i class="fas fa-exclamation-triangle"></i>
              <strong> Nenhum usuário foi importado.</strong> Verifique os
              problemas abaixo.
            </div>

            <div v-if="importErrors.length" class="mt-2">
              <p class="mb-1">
                <strong
                  >Linhas com problema ({{ importErrors.length }}):</strong
                >
              </p>
              <div
                class="table-responsive"
                style="max-height: 220px; overflow-y: auto"
              >
                <table class="table table-sm table-bordered mb-0">
                  <thead class="thead-light">
                    <tr>
                      <th style="width: 70px">Linha</th>
                      <th style="width: 130px">Campo</th>
                      <th>Motivo</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(err, i) in importErrors"
                      :key="i"
                      class="table-warning"
                    >
                      <td class="text-center">{{ err.linha }}</td>
                      <td>
                        <code>{{ err.campo }}</code>
                      </td>
                      <td>{{ err.mensagem }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Cancelar
            </button>
            <button
              type="button"
              class="btn btn-add"
              @click="importFile"
              :disabled="importing"
            >
              <span v-if="importing"
                ><i class="fas fa-spinner fa-spin"></i> Importando...</span
              >
              <span v-else><i class="fas fa-upload"></i> Importar</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <base-crud
          :ref="'usersCrud'"
          crudName="Usuários"
          newText="Novo Usuário"
          :table="table"
          :columns="columns"
          :options="options"
          :endPoint="endPoint"
          :enableAdd="true"
          :enableEdit="true"
          :enableDelete="true"
          :enableView="false"
          :enableReset="false"
          :dataForm="dataForm"
        >
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "usersTable",
      usersCrud: {},
      pages: [],
      url: "",
      // Import modal state
      companies: [],
      units: [],
      importForm: {
        company_id: null,
        unit_id: null,
      },
      importing: false,
      importSuccess: false,
      importedCount: 0,
      importErrors: [],
      columns: [
        "usuario_id",
        "usuario_nome",
        "perfil_id",
        "group_id",
        "status",
        "login",
        "company_id",
        "actions",
      ],
      tableData: [
        "usuario_id",
        "usuario_nome",
        "perfil_id",
        "group_id",
        "status",
        "login",
        "company_id",
      ],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: [
          "usuario_id",
          "usuario_nome",
          "perfil_id",
          "group_id",
          "status",
          "login",
          "company_id",
        ],
        sortable: [
          "usuario_id",
          "usuario_nome",
          "perfil_id",
          "group_id",
          "status",
          "login",
          "company_id",
        ],
        sortIcon: {
          base: "fas",
          up: "fa-chevron-up",
          down: "fa-chevron-down",
          is: "fa-sort",
        },
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        orderBy: { column: "usuario_id", ascending: true },
        headings: {
          usuario_id: "ID",
          usuario_nome: "Nome",
          perfil_id: "Perfil de Acesso",
          group_id: "Grupo",
          status: "Status",
          login: "Login",
          company_id: "Empresa",
          actions: "Ações",
        },

        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        listColumns: {
          perfil_id: [
            {
              id: 1,
              text: "Transporte Sanitario",
            },
            {
              id: 2,
              text: "Administrador",
            },
          ],
          status: [
            {
              id: "1",
              text: "Ativo",
            },
            {
              id: "0",
              text: "Inativo",
            },
          ],
        },
        templates: {
          status: function (h, row, index) {
            if (row.status === "1") {
              return (
                <h5>
                  <span class="badge badge-primary">Ativo</span>
                </h5>
              );
            } else if (row.status === "0") {
              return (
                <h5>
                  <span class="badge badge-danger">Inativo</span>
                </h5>
              );
            }

            return (
              <h5>
                <span class="badge badge-secondary">Desconhecido</span>
              </h5>
            );
          },
          perfil_id: function (h, row, index) {
            if (row.perfil_usuario && row.perfil_usuario.perfil_nome) {
              return row.perfil_usuario.perfil_nome;
            }

            // Fallback baseado no perfil_id
            const perfis = {
              1: "Administrador",
              2: "Usuário",
              20: "Condutor",
            };

            return perfis[row.perfil_id] || "Perfil " + row.perfil_id;
          },
          group_id: function (h, row, index) {
            if (row.group && row.group.group_nome) {
              return row.group.group_nome;
            }
            return <span style="color: #999;">Sem grupo</span>;
          },
          company_id: function (h, row, index) {
            return row.company ? row.company.name : "Sem Nome";
          },

        },
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = [
            "perfil_usuario",
            "group",
            "company",
          ];

          return axios.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this),
          );
        },
      },
      endPoint: "users",
      dataForm: {},
    };
  },
  computed: {
    filteredImportUnits() {
      if (!this.importForm.company_id) return [];
      return this.units.filter(
        (u) => String(u.company_id) === String(this.importForm.company_id),
      );
    },
  },
  components: {
    BaseCrud,
  },
  mounted() {
    this.getCompanies();
    this.getUnits();
  },
  methods: {
    openImportModal() {
      this.importSuccess = false;
      this.importErrors = [];
      this.importedCount = 0;
      if (this.$refs.fileImportRef) {
        this.$refs.fileImportRef.value = "";
      }
      $("#importModal").modal("show");
    },

    onImportCompanyChange() {
      this.importForm.unit_id = null;
    },

    importFile() {
      const self = this;

      if (!self.importForm.company_id) {
        self.$message("Atenção", "Selecione uma empresa.", "warning");
        return;
      }
      if (!self.importForm.unit_id) {
        self.$message("Atenção", "Selecione uma unidade.", "warning");
        return;
      }

      const fileInput = self.$refs.fileImportRef;
      if (!fileInput || !fileInput.files[0]) {
        self.$message(
          "Atenção",
          "Selecione um arquivo para importar.",
          "warning",
        );
        return;
      }

      let fd = new FormData();
      fd.append("fileImport", fileInput.files[0]);
      fd.append("company_id", self.importForm.company_id);
      fd.append("unit_ids[0]", self.importForm.unit_id);

      self.importing = true;
      self.importSuccess = false;
      self.importErrors = [];

      axios
        .post(self.$store.state.api + "import-users", fd)
        .then((response) => {
          self.importedCount = response.data.imported || 0;
          self.importErrors = response.data.errors || [];
          self.importSuccess = true;
          if (self.importedCount > 0) {
            self.$refs.usersCrud.$refs.table.refresh();
          }
        })
        .catch((error) => {
          const data = error.response?.data;
          // Validation errors from Laravel (422)
          if (data?.errors) {
            const msgs = Object.values(data.errors).flat().join(" ");
            self.$message("Erro de validação", msgs, "error");
          } else {
            self.$message(
              "Erro na importação",
              data?.message ||
                "Houve um erro inesperado. Verifique o arquivo e tente novamente.",
              "error",
            );
          }
        })
        .finally(() => {
          self.importing = false;
        });
    },

    getCompanies() {
      axios
        .get(this.$store.state.api + "companies?paginated=false&status=1")
        .then((response) => {
          this.companies = response.data.data;
        })
        .catch(() => {});
    },

    getUnits() {
      axios
        .get(this.$store.state.api + "units?paginated=false&status=1")
        .then((response) => {
          this.units = response.data.data;
        })
        .catch(() => {});
    },

    query: function (query) {
      let columns = {
        usuario_id: "usuario_id",
        usuario_nome: "usuario_nome",
        perfil_id: "perfil_id",
        group_id: "group_id",
        status: "status",
        login: "login",
        company_id: "company[name]",
      };
      let filters = "";
      $.each(query, function (index, value) {
        if (columns[index] !== undefined) {
          filters += columns[index] + "=" + value + "&";
        }
      });
      return filters;
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}

.uploading-image {
  display: flex;
  border-radius: 10px;
  width: 100px;
  height: 100px;
}
</style>
